export default __webpack_public_path__ + "static/media/icon-telecharger_un_dossier.ed80809e.svg";